import './MarqueeRow.css';

/**
 * MarqueeRow
 * A row of cards that scrolls on its own, forever, in either direction.
 * `reverse` flips it to scroll right instead of left by playing the same
 * CSS animation backwards - no separate keyframanswer needed.
 * Pauses on hover/focus, and respects prefers-reduced-motion (becomes a
 * normal horizontally-scrollable row instead).
 */
export default function MarqueeRow({
  items,
  renderItem,
  reverse = false,
  duration = 34,
  className = '',
}) {
  const track = [...items, ...items];

  return (
    <div className={`marquee-row ${className}`}>
      <div
        className={`marquee-row__track ${reverse ? 'marquee-row__track--reverse' : ''}`}
        style={{ animationDuration: `${duration}s` }}
      >
        {track.map((item, i) => (
          <div className="marquee-row__item" key={i}>
            {renderItem(item)}
          </div>
        ))}
      </div>
    </div>
  );
}